import Translate from '@appsflyer/fe-service-translate';
import DEFAULT_LOCALE from '../locales/en.json';

const LOCALES_NS = 'uiCore';

Translate.addDefaultLocale(DEFAULT_LOCALE, LOCALES_NS);

const translate = (key, attributes) => {
  return Translate.localizedString(key, attributes, LOCALES_NS);
};

export { translate };
